import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { useConversationAnalysisAlertsList } from '@/Domain/hooks/Conversation/useConversationAnalysisAlertsList.hook';
import { ManageAlertsPage } from '@/UI/Insights/ManageAlerts/ManageAlerts.page';

export const ManageAlertsLoader = () => {
  const query = useConversationAnalysisAlertsList();

  if (query.isLoading) {
    return <CenterSpinner />;
  }

  return <ManageAlertsPage alerts={query.data || []} />;
};
